import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStep1 = createIcon({
  viewBox: '0 0 36 36',
  path: (
    <>
      {' '}
      <circle cx="18" cy="18" r="17.5" fill="white" stroke="#0D47A1" />
      <path
        d="M20.872 21.896C21.064 21.896 21.2133 21.944 21.32 22.04C21.4267 22.136 21.48 22.2693 21.48 22.44C21.48 22.6213 21.4267 22.76 21.32 22.856C21.224 22.952 21.0747 23 20.872 23H15.576C15.3733 23 15.2187 22.952 15.112 22.856C15.016 22.76 14.968 22.6213 14.968 22.44C14.968 22.2693 15.0213 22.136 15.128 22.04C15.2347 21.944 15.384 21.896 15.576 21.896H17.56V13.32L15.816 14.456C15.7307 14.5093 15.6453 14.536 15.56 14.536C15.4107 14.536 15.2773 14.4667 15.16 14.328C15.0533 14.1893 15 14.04 15 13.88C15 13.656 15.0853 13.496 15.256 13.4L17.688 11.816C17.8693 11.6987 18.056 11.64 18.248 11.64C18.4293 11.64 18.5787 11.6987 18.696 11.816C18.8133 11.9333 18.872 12.0987 18.872 12.312V21.896H20.872Z"
        fill="#0D47A1"
      />
    </>
  ),
});

export default IconStep1;
